import { createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk to update a task
export const updateTaskThunk = createAsyncThunk(
  'projectDraft/updateTask',
  async ({ phaseId, taskId, updates }, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState().projectDraft;
      const firestoreId = state.firestoreDraftId;

      if (firestoreId) {
        const { updateTaskInFirebase } = await import('../../../pages/home/Projects/api/projectOperations');
        await updateTaskInFirebase(firestoreId, phaseId, taskId, updates);
      }

      // Update local state
      dispatch({ type: 'projectDraft/updateTaskLocal', payload: { phaseId, taskId, updates } });

      return { phaseId, taskId, updates };
    } catch (error) {
      console.error('Failed to update task:', error);
      return rejectWithValue(error.message);
    }
  }
);
